import o from"./symbol-constructor-detection.js";var t=o,r=t&&!Symbol.sham&&typeof Symbol.iterator=="symbol";export{r as default};
